import { Injectable } from '@angular/core';
import { ApiHttpClient, ListOption } from '../modules/tcm-core.module';
import { AuthorizationTypeEnum } from '../models/authorizations';

@Injectable({
  providedIn: 'root'
})
export class AuthorizationsDataService {
  constructor(private readonly httpClient: ApiHttpClient) {
  }

  public getPatientAuthorizationsAsync(query: string, patientId: number, type: AuthorizationTypeEnum, timeout: Promise<any>, allowLegacy: boolean = false): Promise<ListOption<number>[]> {
    const request = { searchString: query, patientId: patientId, authorizationType: type, allowLegacy: allowLegacy };
    return this.httpClient.getJsonAsync<ListOption<number>[]>('authorizations/options', request, timeout);
  }

  public deleteAuthorizationAsync(id: number | string, timeout: Promise<any>): Promise<any> {
    return this.httpClient.postJsonAsync('authorizations/delete', id, timeout);
  }

}
